module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//9.jpg?86c72873fa4055be7daf25beddc72d65";